'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');
const moment = require('moment');

import routes from './admin-home.routes';

export class AdminHomeComponent {

  constructor(VotingsService, SettingsService, PropertyService, VoterGroupsService, User, ClosingSnapshotsService) {
    'ngInject';

    this.currentPage = 1;
    this.itemsPerPage = 3;

    this.ballotsVisible = {};

    this.chartOptionsStartFromZero = {
      scales: {
        xAxes: [{
          ticks: {
            beginAtZero: true
          }
        }],
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      }
    };

    this.count = {
      properties: 0,
      blocked: 0,
      evoter: 0,
      papervoter: 0
    };

    this.VoterGroupsService = VoterGroupsService;
    this.ClosingSnapshotsService = ClosingSnapshotsService;

    SettingsService.getByName({name: 'config.platform'}, settings => {
      if (settings.data.managementSuite && settings.data.managementSuite.baseUrl)
        this.suiteURL = settings.data.managementSuite.baseUrl;
    });

    ClosingSnapshotsService.getIds(snapshots => {

      this.snapshots = snapshots;

      SettingsService.getByName({name: 'config.app'}, settings => {
        let ssDT = settings.data.serverSideDT || {};
        this.serverSideDT = ssDT && ssDT.voterGroups && ssDT.voterGroups.enabled;

        SettingsService.getByName({name: 'client'}, settings => {
          this.proxyVoteAllowed = settings.data.proxy && settings.data.proxy.canVote;
          this.quorumThreshold = settings.data.quorum || 0;
          this.useSuite = settings.data.useSuite;

          let PROPERTIES_METHOD = (this.useSuite)
            ? User.querySuite
            : PropertyService.getPropertiesVoting;

          PROPERTIES_METHOD(data => {

            if (data && data[0]) {
              this.properties = data.filter(d => d.json).map(d => JSON.parse(d.json));

              if (this.useSuite)
                this.properties = this.properties.map(p => {
                  let ppty = p;
                  if (!ppty.property.eVoting) ppty.property.eVoting = {};
                  ppty.property.eVoting.voter = p.contact;
                  return ppty;
                });

              this.count.properties = this.properties.length;
              this.count.blocked = this.properties.filter(o => o.property.eVoting && o.property.eVoting.voter && o.property.eVoting.blocked).length;
              this.count.evoter = this.properties.filter(o => o.property.eVoting && o.property.eVoting.voter && !o.property.eVoting.blocked && o.property.eVoting.voter.customFields && o.property.eVoting.voter.customFields.eVotingConsent).length;
              this.count.papervoter = this.properties.filter(o => o.property.eVoting && o.property.eVoting.voter && !o.property.eVoting.blocked && (!o.property.eVoting.voter.customFields || !o.property.eVoting.voter.customFields.eVotingConsent)).length;
            }

            VotingsService.query((data) => {
              this.votings = data.filter(voting => (
                (voting.voterGroup && typeof voting.voterGroup === 'object')
                || (voting.state == 'closed' && voting.closingSnapshot && this.snapshots.find(snap => String(snap._id) == (voting.closingSnapshot)))));

              this.votings.forEach(voting => {
                let snapshot = this.snapshots.find(s => s.voting == voting._id);
                let quorumMap = {};

                if (voting.state == 'closed' && snapshot) {
                  quorumIds = snapshot.data;
                  voting.snapshotDate = snapshot.meta.clientDate || snapshot.meta.creationDate;
                  voting.snapshotVGName = snapshot.name;
                  voting.voterGroup = snapshot;

                  if (snapshot.type == 'contacts')
                    voting.voterGroup.contacts = voting.voterGroup.data;
                  else
                    voting.voterGroup.properties = voting.voterGroup.data;

                  delete voting.voterGroup.data;
                }
                voting.quorum = 0;
                voting.attended = 0;
                voting.totalVotings = 0;
                voting.propertiesWithProxies = 0;
                voting.hasQuorum = 0;
                voting.isContactVoting = voting.voterGroup.type == 'contacts';
                voting.voters = (voting.isContactVoting) ? voting.voterGroup.contacts.length : voting.voterGroup.properties.length;

                this.ballotsVisible[voting._id] = false;

                let quorumIds = (voting.isContactVoting) ? voting.voterGroup.contacts : voting.voterGroup.properties;

                quorumIds.forEach(id => quorumMap[id] = 0);

                if (!voting.isContactVoting) {

                  voting.attendances.forEach(att => {
                    if (att.attended && quorumIds.includes(att.property)) {
                      voting.attended++;
                      quorumMap[att.property]++;
                    }
                    /*
                    let voter = this.properties.find(u => u.contact._id == att.voter && u.property._id == att.property);
                    if (voter) voter.attended = att.attended;

                    if (voter && voter.attended && quorumMap.hasOwnProperty(att.property)) {
                      voting.attended++;
                      quorumMap[att.property]++;
                    }
                     */
                  });

                  voting.proxies.forEach(prox => {
                    if (!prox.proxy.enabled) return;

                    if (prox.proxy.type == 'default'
                      || (prox.proxy.type == 'write-in' && prox.proxy.writeInProxyName && prox.proxy.writeInProxyApproved)) {

                      if (quorumMap.hasOwnProperty(prox.property)) {
                        voting.propertiesWithProxies++;
                        quorumMap[prox.property]++;
                      }
                    }
                    /*
                    let voter = this.users.find(u => u.contact._id == prox.voter && u.property._id == prox.property);
                    if (voter) voter.proxy = prox.proxy;

                    if (voter && voter.proxy && quorumMap.hasOwnProperty(prox.property)) {
                      if (!prox.proxy.enabled) return;

                      if (prox.proxy.type == 'default' || (prox.proxy.type == 'write-in' && prox.proxy.writeInProxyName && prox.proxy.writeInProxyApproved)) {
                        voting.propertiesWithProxies++;
                        quorumMap[prox.property]++;
                      }
                    }
                     */
                  });

                  voting.votes.forEach(vote => {
                    if (quorumMap.hasOwnProperty(vote.property)) {
                      voting.totalVotings++;
                      quorumMap[vote.property]++;
                    }
                  });
                } else { // contact voting
                  voting.votes.forEach(vote => {
                    if (quorumMap.hasOwnProperty(vote.voter)) {
                      voting.totalVotings++;
                      quorumMap[vote.voter]++;
                    }
                  });
                }

                Object.keys(quorumMap).forEach(id => {
                  if (quorumMap[id]) { // > 0
                    voting.hasQuorum++;
                  }
                });

                voting.quorum = voting.hasQuorum / quorumIds.length;
              });

              this.upcoming = this.votings
                .filter(v => v.state != 'closed')
                .filter(v => moment(v.period.till).isAfter(moment()));

              this.past = this.votings
                .filter(v => v.state == 'closed' || moment(v.period.till).isBefore(moment()))
                .sort((a, b) => { return new Date(b.date) - new Date(a.date) });

              this.dataInitComplete = true;
            }, err => {
              console.log("Could not retrieve votes.")
            });

          }, err => {
            console.log("Could not retrieve users.")
          });

        });
      });

    });

  }

  getVotesPerBallot(ballotId, voting) {
    return [... new Set(voting.votes.filter(v => v.ballot == ballotId).map(v => voting.isContactVoting  ? v.contact : v.property))].length;
  }

}

export default angular.module('conduu.adminHome', [uiRouter])
  .config(routes)
  .component('adminHome', {
    template: require('./admin-home.html'),
    controller: AdminHomeComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin-home/admin-home.component.js